module.exports = __webpack_public_path__ + "img/bars-solid.a9dd59a2.svg";